import { KzIconBuilding } from '@kaizenplatform/kaizen-icon-elements';

import { createIconElement } from './createIconElement';

export const Building = createIconElement(KzIconBuilding);
